import { useState } from 'react';

export default function AuthorAvatar({
  name,
  photo,
  className,
}: {
  name: string;
  photo?: string | null;
  className: string;
}) {
  const [failed, setFailed] = useState(false);
  if (photo && !failed) {
    return <img src={photo} alt={name} className={className} onError={() => setFailed(true)} />;
  }
  const initials = name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0])
    .join('');
  return (
    <span
      aria-hidden="true"
      className={`${className} inline-flex shrink-0 items-center justify-center bg-blue-50 text-blue-600 text-xs font-semibold`}
    >
      {initials || 'SP'}
    </span>
  );
}
